import { appURLS } from 'appRoot/app.constants';

const NS = 'PouchBulkService';

const logTag = `[Pouch DB - ${NS}] ==>`;

class PouchBulkService {

  public async loadDump(syncLogStack: string[], reducedInfo: {url: string, username: string, password: string}, dbLocal: any, venueId: number, getBearerToken: () => string) {

    try{
      console.log(logTag, `4. Starting loadDump reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
      syncLogStack.push(`4. Starting loadDump reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);  
    }
    catch (err)
    {
      console.error(`4. Starting loadDump -> log ${err}`);
    }
    // Dump feature disabled
    if (window.config.pouch.bulkLoad !== true) {
      try{
        console.log(logTag, `4.0. loadDump aborted reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
        syncLogStack.push(`4.0. loadDump aborted reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
      }
      catch (err)
      {
        console.error(`4.0. loadDump aborted -> log ${err}`);
      }
      return;
    }

    // Optionally import dump
    const isLoaded = await this.isBulkLoaded(dbLocal);

    // Guard from load previously done
    if (isLoaded) {
      // console.log(logTag, );
      try{
        console.log(logTag, `4.1. BulkLoad previously imported reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
        syncLogStack.push(`4.1. BulkLoad previously imported reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
      }
      catch (err)
      {
        console.error(`4.1. BulkLoad previously imported -> log ${err}`);
      }
      return;
    }
    // Import the dump
    // var startTime = performance.now();
    try {
      await this.bulkLoad(dbLocal, reducedInfo, venueId, getBearerToken)
      // var endTime = performance.now();
      // console.log(logTag, '4.2. BulkLoad completed in', (endTime - startTime) / 1000, 'seconds');
      try{
        console.log(logTag, `4.2. BulkLoad completed reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
        syncLogStack.push(`4.2. BulkLoad completed reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
      }
      catch (err)
      {
        console.error(`4.2. BulkLoad completed -> log ${err}`);
      }
    } catch (e) {
      try{
        console.error(logTag, `4.9 BulkLoad import failed reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
        syncLogStack.push(`4.9 BulkLoad import failed reducedInfo: ${reducedInfo?.url || ''}, dbLocal: ${dbLocal?.url || ''}, venueId:${venueId}  >>`);
      }
      catch (err)
      {
        console.error(`4.9 BulkLoad import failed -> log ${err}`);
      }
    }
  }

  public async isBulkLoaded(dbLocal: any) {
    try {
      await dbLocal.get('_local/initial_load_complete');
      return true;
    } catch (err: any) {
      if (err.status !== 404) {
        throw new Error(err.toString());
      }
      return false;
    }
  }

  public async bulkLoad(dbLocal: any, reducedInfo: {url: string, username: string, password: string}, venueId: number, getBearerToken: () => string) {
    // Import parameters
    const dumpURL = appURLS.API + '/restaurants/venues/dump-reduced/' + venueId;
    const dumpOptions = {
      proxy: reducedInfo.url,

      auth: {
        username: reducedInfo.username,
        password: reducedInfo.password,
      },
      ajax: {
        headers: {
          'Authorization': getBearerToken()
        }
      }
    };
    // Load the dump
    // console.log(logTag, 'BulkLoad, request dump from', dumpURL, dumpOptions);
    return dbLocal.load(dumpURL, dumpOptions).then(() => {
      dbLocal.put({
        _id: '_local/initial_load_complete',
      });
    });
  }
}

const instance = new PouchBulkService();
export default instance as PouchBulkService;
